module.exports = __webpack_public_path__ + "static/media/vice.44933614.jpg";